import type { InputHTMLAttributes } from 'react';

import { colors } from '../../colors';
import { MagnifyingGlassIcon } from '../icons';

import * as css from './SearchInput.css';

export interface SearchInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> {
    /** Controlled input value. */
    value: string;

    /** Called with the next string value when the input changes. */
    onChange: (value: string) => void;

    /** Placeholder text shown when empty. */
    placeholder?: string;

    /** Disables the input and applies disabled styling. */
    disabled?: boolean;
}

export function SearchInput({ value, onChange, placeholder, disabled }: SearchInputProps) {
    return (
        <div className={css.inputField({ disabled })}>
            <input
                className={css.input({ disabled })}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                disabled={disabled}
            />
            <div className={css.searchIcon}>
                <MagnifyingGlassIcon size={24} color={!disabled ? colors.blue[500] : colors.gray[300]} />
            </div>
        </div>
    );
}
